module.exports = __webpack_public_path__ + "assets/conciseLanguage.761eca34.svg";